<template>
    <div class="merge-source-wrapper mb-0 subscribers-wrapper mr-1" v-click-outside="closeDropdown">
        <form-input id="source" @input="(value) => onSearch(value)" :value="searchValue" :placeholder="placeholder"
            autocomplete="off" :floatingLabel="floatingLabel" :rightButton="rightButton" :rightButton2="rightButton2"
            @handle-right-button-click="onRightButtonClick" @handle-right-button-2-click="onRightButton2Click"
            :error="error" class="w-100" />
        <div class="merge-guests-wrapper subscribers-list-wrapper" v-if="!!searchValue && isSearching">
            <div class="guest-item p-2 d-flex align-items-center justify-content-center">
                <b-spinner variant="primary" :small="true" />
            </div>
        </div>
        <div class="merge-guests-wrapper subscribers-list-wrapper"
            v-else-if="showList && !selectedResult && searchResults.length">
            <div class="w-100" v-if="isGrouped">
                <div class="search-field-option-group" v-for="group in Object.keys(filteredGroupedOptions)" :key="group">
                    <span class="search-field-option-group-label">{{ formatGroup(group) }}</span>
                    <div class="guest-item p-2 pl-4" v-for="option in filteredGroupedOptions[group]" :key="option.value"
                        @click="selectResult(option.text, option.value)">
                        <span>{{ option.text }}</span>
                    </div>
                </div>
            </div>
            <div v-else class="w-100">
                <div class="guest-item p-2" :key="result.id" v-for="result in searchResults"
                    @click="selectResult(result.text, result.value)">
                    <span>{{ result.text }}</span>
                </div>
            </div>
        </div>
        <div class="merge-guests-wrapper subscribers-list-wrapper"
            v-else-if="showList && !searchResults.length && !!searchValue && !selectedResult">
            <div class="p-2">
                <span class="text-center">Nothing found</span>
            </div>
        </div>
        <div v-else />
    </div>
</template>

<script>
import capitalize from 'lodash/capitalize';
import FormInput from '../form-input/form-input.vue';
import groupBy from 'lodash/groupBy';
export default {
    name: 'FormSearchField',
    components: { FormInput },
    props: {
        busy: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        value: {
            type: String,
            default: '',
        },
        error: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        floatingLabel: {
            type: String,
            default: null,
        },
        rightButton: {
            type: Object,
            default: null,
        },
        rightButton2: {
            type: Object,
            default: null,
        },
        isGrouped: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchValue: this.value,
            searchResults: this.options,
            isSearching: this.busy,
            selectedResult: '',
            showList: false,
        };
    },
    watch: {
        value(val) {
            this.searchValue = val;
        },
        options(val) {
            this.searchResults = val;
        },
        busy(val) {
            this.isSearching = val;
        },
    },
    computed: {
        filteredGroupedOptions() {
            return groupBy(this.searchResults, 'group');
        },
    },
    methods: {
        onSearch(value) {
            this.searchValue = value;
            if (!value.trim()) {
                this.selectedResult = '';
            }
            this.showList = true;
            this.$emit('input', value);
        },
        closeDropdown() {
            this.showList = false;
        },
        selectResult(text, value) {
            this.searchValue = text;
            this.selectedResult = value;
            this.searchResults = [];
            this.showList = false;
            this.$emit('select', text, value);
        },
        onRightButtonClick() {
            this.selectedResult = '';
            if (this.searchResults.length === 0) {
                this.showList = true;
            } else {
                this.showList = !this.showList;
            }
            this.$emit('right-button-click');
        },
        onRightButton2Click() {
            this.$emit('right-button2-click');
        },
        formatGroup(group) {
            return capitalize(group.split('_').join(' '))
        },
    },
};
</script>

<style lang="scss" scoped>
.subscribers-list-wrapper {
    top: 40px;
}

.subscribers-wrapper {
    min-width: 300px;
}

.search-field-option-group-label {
    padding: 10px;
    font-weight: bold;
    border-bottom: 1px solid #cdcdcd;
    display: block;
    font-size: 15px;
    text-transform: capitalize;
}
</style>